interface Props {
  label: string;
  value: number;
}

// Colour the fill by where the score lands, so a weak axis reads as weak at a
// glance rather than every bar looking the same brand blue.
function fillClass(value: number): string {
  if (value <= 40) return 'bg-danger';
  if (value <= 70) return 'bg-warning';
  return 'bg-success';
}

export default function AxisBar({ label, value }: Props) {
  return (
    <div>
      <div className="mb-2 flex items-baseline justify-between">
        <span className="font-medium text-heading">{label}</span>
        <span className="tabular-nums">
          <span className="text-2xl font-bold text-heading">{value}</span>
          <span className="text-sm text-muted"> / 100</span>
        </span>
      </div>
      <div
        role="progressbar"
        aria-label={label}
        aria-valuenow={value}
        aria-valuemax={100}
        aria-valuemin={0}
        className="h-3 w-full overflow-hidden rounded-full bg-surface"
      >
        <div
          className={`h-full rounded-full transition-all duration-700 ${fillClass(value)}`}
          style={{ width: `${Math.max(value, 2)}%` }}
        />
      </div>
    </div>
  );
}
